<header>
    <div class="header-left">
        <button (click)="drawerService.toggle()" class="header-icon" mat-icon-button>
            <mat-icon>menu</mat-icon>
        </button>

        <img
            class="header-logo"
            [src]="isMobile ? '/assets/images/ps-logo-small.png' : '/assets/images/ps-business.png'"
            alt="ps logo" />
        |
        <img
            class="h-[26px]"
            [src]="
                isMobile ? '/assets/images/tm-logo-small.png' : '/assets/images/tokio-marine-insurance-logo.pngw3.webp'
            "
            alt="tm logo" />
    </div>
    <div class="header-right">
        <button [matMenuTriggerFor]="menu" class="header-icon avatar" mat-icon-button>
            <mat-icon>person</mat-icon>
        </button>

        <mat-menu #menu="matMenu">
            <button (click)="authService.logout()" mat-menu-item>Logout</button>
        </mat-menu>
    </div>
</header>
